import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Game from '../pages/Game';
import { servicesWorkerHandlePageLoad } from '../serviceWorkerRegistration';

const MainRoutes = () => {
  useEffect(() => {
    servicesWorkerHandlePageLoad();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Game />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MainRoutes;
